import { eula_es } from './eula_es';

export const locale_es = {
  ...eula_es,
  AddNew: 'Agregar nuevo',
  SearchText: 'Ingresar texto de búsqueda...',
  ClearFilter: 'Borrar filtro',
  Cancel: 'Cancelar',
  OK: 'OK',
  Yes: 'Si',
  No: 'No',
  Description: 'Descripción',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  MyProfile: 'Mi perfil',
  CloseSession: 'Cerrar sesión',
  Settings: 'Configuración',
  hrs: 'horas',
  EditTask: 'Editar tarea',
  DeleteTaskQuestion: '¿Está seguro de eliminar esta tarea?',
  Delete: 'Eliminar',
  Reader: 'Lector',
  Contributor: 'Colaborador',
  Permissions: 'Permisos',
  Welcome: 'Bienvenido',
  SelectEntity: 'Seleccionar entidad',
  SetEntityTitle: 'Establecer título de entidad',
  SetEntityType: 'Establecer tipo de entidad',
  Add: 'Agregar',
  SelectGroup: 'Seleccionar grupo',
  SelectGroups: 'Seleccionar Grupos',
  SelectOrganization: 'Seleccionar organización',
  SelectPermissions: 'Seleccionar permisos',
  EntityType: 'Tipo de entidad',
  SelectRoles: 'Seleccionar roles',
  SelectUser: 'Seleccionar usuario',
  SelectUsers: 'Seleccionar usuarios',
  SelectVisibility: 'Seleccionar visibilidad',

  Name: 'Nombre',
  PleaseEnterName: 'Por favor ingrese un nombre',
  PleaseSelectASelector: 'Seleccione un selector',
  Save: 'Guardar',
  Reset: 'Restablecer',
  AddMembersToGroup: 'Agregar miembros al grupo',
  AreYouSureRemove: '¿Está seguro de que desea eliminarlo?',
  AreYouSureRemoveMember: '¿Está seguro de que desea eliminar a {0} miembro del grupo?',
  AreYouSureRemoveMembers: '¿Está seguro de que desea eliminar a {0} miembros del grupo?',
  User: 'Usuario',
  Search: 'Buscar',
  AddMembers: 'Agregar miembros',
  Reload: 'Recargar',
  AssignPermissionsToGroup: 'Asignar permisos al grupo',
  Entity: 'Entidad',
  Roles: 'Roles',
  Role: 'Rol',
  AdminRoles: 'Roles de administrador',
  DefaultRoles: 'Roles predeterminados',
  PermissionsAssigned: 'Permisos asignados',
  SearchEntity: 'Buscar entidad',
  AssignNewRolesToGroup: 'Asignar nuevos roles al grupo',
  AreYouSureWantToUnassignRole: '¿Está seguro de que desea cancelar la asignación de {0} roles?',
  AreYouSureWantToUnassignRoles: '¿Está seguro de que desea desasignar {0} roles?',
  AssignedRoles: 'Roles asignados',
  AssignRoles: 'Asignar roles',
  GroupParam: 'Grupo {0}',
  Members: 'Miembros',
  Groups: 'Grupos',
  NuevoGrupo: 'Nuevo Grupo',
  IdentityAdministration: 'Administración de identidad',
  OrganizationsManagement: 'Gestión de Organizaciones',
  UsersManagement: 'Gestión de usuarios',
  RolesManagement: 'Gestión de roles',
  AdminRolesManagement: 'Gestión de roles de administrador',
  GroupsManagement: 'Gestión de grupos',
  PermissionsManagement: 'Gestión de permisos',
  RoleAssignmentsManagement: 'Administración de asignaciones de roles',
  DefaultRolesManagement: 'Administración de funciones predeterminadas',
  AuditLogs: 'Registros de auditoría',
  Organizations: 'Organizaciones',
  Users: 'Usuarios',
  Assignments: 'Asignaciones de roles',
  Logout: 'Cerrar sesión',
  OrganizationDatabaseHasBeenCreated: 'Se ha creado la base de datos de la organización',
  SomethingWentWrong: 'Algo salió mal',
  OrganizationHasBeenBlocked: 'La organización ha sido bloqueada',
  OrganizationHasBeenUnblocked: 'La organización ha sido desbloqueada',
  EditPartnerOrganization: 'Editar organización asociada',
  SelectOrRemovePartnerOrganizationMessage: 'Seleccione una nueva organización asociada para {0}',
  PleaseSelectAPartnerOrganization: 'Por favor, seleccione una organización asociada',
  Warning: 'Advertencia',
  TestingEndDateAutomaticallyChangedWarning:
    'La fecha de finalización de pruebas de la organización asociada seleccionada es anterior a la fecha de finalización de pruebas seleccionada actualmente para esta organización. La fecha de finalización de pruebas se ha actualizado automáticamente para que coincida con la fecha de finalización de pruebas de la organización asociada.',
  OrgCannotChangePartnerStatusWarning:
    'El estado de organización socia de esta organización no se puede modificar mientras tenga organizaciones hijas.',
  IsPartner: 'Es Socio',
  IsBlocked: 'Está bloqueado',
  DisplayName: 'Nombre para mostrar',
  Email: 'Correo electrónico',
  PleaseEnterAValidEmail: 'Ingrese un correo electrónico válido',
  Address: 'Dirección',
  PleaseEnterAnAddress: 'Por favor ingrese una dirección',
  PartnerOrganization: 'Organización socia',
  EnsureDB: 'Asegurar DB',
  Unblock: 'Desbloquear',
  Block: 'Bloquear',
  AddMembersToOrganization: 'Agregar miembros a la organización',
  OrganizationMembers: 'Miembros de la organización',
  OrganizaciónParam: 'Organización {0}',
  NewOrganization: 'Nueva organización',
  CreatingOrganizationMessage: 'Creando organización y su base de datos. Esto podría tomar varios minutos. Espere por favor',
  RoleAssignments: 'Asignaciones de roles',
  Identity: 'Identidad',
  SelectType: 'Seleccionar tipo',
  Group: 'Grupo',
  IdentityType: 'Tipo de identidad',
  SearchIdentity: 'Identidad de búsqueda',
  NewRolesAssignment: 'Nueva asignación de roles',
  Visibility: 'Visibilidad',
  PleaseSelect: 'Seleccione por favor',
  Category: 'Categoría',
  PleaseEnterACategory: 'Por favor ingrese una categoría',
  AssignNewRolesToPermission: 'Asignar nuevos roles al permiso',
  PermissionParam: 'Permiso {0}',
  NewPermission: 'Nuevo permiso',
  Organization: 'Organización',
  AddRoleToGroups: 'Agregar rol a grupos',
  AreYouSureRemoveRole: '¿Está seguro de que desea eliminar el rol de?',
  RoleGroups: 'Grupos de roles',
  AddToGroups: 'Agregar a grupos',
  AddPermissionsToRole: 'Agregar permisos al rol',
  Permission: 'Permiso',
  RolePermissions: 'Permisos de función',
  AddToPermissions: 'Agregar a permisos',
  AddUsersToRole: 'Agregar usuarios al rol',
  RoleUsers: 'Usuarios de roles',
  AddUsers: 'Agregar usuarios',
  RolParam: 'Rol {0}',
  NewRole: 'Nuevo rol',
  AddUserToGroups: 'Agregar usuario a grupos',
  AreYouSureRemoveUserFromGroup: '¿Está seguro de que desea eliminar al usuario del grupo {0}?',
  AreYouSureRemoveUserFromGroups: '¿Está seguro de que desea eliminar al usuario de {0} grupos?',
  GroupMembership: 'Membresía del grupo',
  AssignPermissionsToUser: 'Asignar permisos al usuario',
  AssignNewRolesToUser: 'Asignar nuevos roles al usuario',
  UserParam: 'Usuario {0}',
  PasswordMustMatch: 'La contraseña debe coincidir',
  NewUser: 'Nuevo usuario',
  PleaseSelectAnOrganization: 'Seleccione una organización',
  SetPassword: 'Establecer contraseña',
  SendInvitation: 'Enviar invitación',
  Password: 'Contraseña',
  ConfirmPassword: 'Confirmar contraseña',
  PasswordFieldBlankMessage:
    'Si deja el campo de contraseña en blanco, el sistema asumirá que este usuario utilizará un proveedor de autenticación externo para iniciar sesión',
  AdminZone: 'Zona de administración',
  ReviewClaims: 'Revisar reclamaciones',
  ReviewGrants: 'Revisar subvenciones',
  PageDoesNotExist: 'Lo siento, la página que visitó no existe',
  BackHome: 'Volver a casa',
  Home: 'Home',
  DontHaveAccessToTheAdminSite: 'No tiene acceso al sitio de administración',
  RedirectingToLandingPage: 'Redireccionando a la página de destino en',
  Go: 'Ir',
  DefaultLanguage: 'Idioma predeterminado',
  PleaseSelectALanguage: 'Por favor seleccione un idioma',
  SelectLanguage: 'Seleccionar idioma',
  Languages: 'Idiomas',
  to: 'a',
  from: 'de',
  DownloadTemplate: 'Descargar plantilla',
  ConfirmationRequired: 'Confirmación requerida',
  Confirmation: 'Confirmación',
  AreYouSureDeleteAllItems: '¿Está seguro de que desea eliminar todos los elementos?',
  AreYouSureYouWantToDelete: '¿Está seguro de que desea eliminar los elementos seleccionados?',
  AreYouSureYouWantToDeleteSelected: '¿Está seguro de que desea eliminar los elementos seleccionados?',
  UploadComplete: 'Carga completa',
  DeleteElements: 'Eliminar elementos',
  DeleteItems: 'Eliminar elementos',
  DeleteSelected: 'Eliminar seleccionado',
  BulkUploadItems: 'Elementos de carga masiva',
  DeleteAll: 'Eliminar Todo',
  OrderBy: 'Ordenar por',
  AnErrorOcurred: 'Ha ocurrido un error',
  NoData: 'Sin datos',
  ResetFilter: 'Reiniciar filtro',
  SelectAll: 'Seleccionar todo',
  FilterConfirm: 'Confirmar filtro',
  Filter: 'Filtro',
  InvertSelection: 'Invertir selección',
  Sort: 'Ordenar',
  ElementsDeletedSuccessfully: 'Los elementos se eliminaron correctamente',
  AreYouSureDiscardChanges: '¿Está seguro de que desea descartar estos cambios?',
  TotalElements: 'Elementos totales',
  TotalImported: 'Total importado',
  DownloadErrorsFile: 'Descargar archivo de errores',
  Errors: 'Errores',
  DownloadWarningsFile: 'Descargar archivo de advertencias',
  Warnings: 'Advertencias',
  UnsavedValuesWarning: 'Hay cambios sin guardar. Seguro que quieres salir?',
  DeletedElements: 'Elementos eliminados',
  FailDeletion: 'Error en la eliminación',
  NotSet: 'No establecido',
  CanNotDeleteOwnUser: 'No se puede eliminar el propio usuario',
  CanNotDeleteOwnOrganization: 'No se puede eliminar la propia organización',

  //Home
  WelcomeBack: '¡Bienvenido de nuevo, {0}!',
  PageDoesNotExists: 'Lo siento, la página que visitaste no existe.',

  //Paging
  Page: 'Página',
  GoTo: 'Ir a',

  //Roles Views
  Selector: 'Selector',
  AssignToScopeCreator: 'Asignar al Creador de Contexto',
  EditRole: 'Editar rol',
  Edit: 'Editar',
  EditDefaultRole: 'Editar rol predeterminado',
  CreateDefaultRole: 'Crear rol predeterminado',
  NewDefaultRole: 'Nuevo rol predeterminado',
  DeleteMember: 'Eliminar miembro',
  DeleteMembers: 'Eliminar miembros',
  RemoveMember: 'Eliminar miembro',
  RemoveMembers: 'Eliminar miembros',
  CreateRole: 'Crear Rol',
  RolesPermissions: 'Permisos de funciones',
  GeneralProperties: 'Propiedades generales',
  SelectSelector: 'Seleccionar Selector',
  AssignByDefaultToScopeCreator: 'Asignar por defecto al creador de contexto',
  SaveChanges: 'Guardar cambios',
  Allow: 'Permitir',
  Deny: 'Negar',
  Partners: 'Socios',
  EditAdminRole: 'Editar rol de administrador',
  RoleName: 'Nombre de rol',
  NewAdminRole: 'Nueva función de administrador',
  PartnersOnlyQuestion: '¿Solo socios?',
  PartnersOnly: 'Solo socios',
  DefaultRoleWarning:
    'Este rol predeterminado genera roles que se asignan de forma predeterminada a los creadores de algunos tipos de ámbitos. Proceda con precaución',
  DefaultRoleDeleteWarning:
    'Este rol predeterminado genera roles que se asignan de forma predeterminada a los creadores de algunos tipos de ámbitos. ¿Seguro que quieres borrarlo?',
  ChooseIdentity: 'Elegir Identidad:',
  RoleIsBeingAssignedToDefaultCreators:
    'Este rol se asigna de forma predeterminada a los creadores de algunos tipos de ámbitos. Proceda con precaución',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'Este rol se asigna de forma predeterminada a los creadores de algunos tipos de ámbitos. ¿Seguro que quieres borrarlo?',
  RoleDelete: '¿Está seguro de que quiere eliminar este rol?',
  DefaultRoleDelete: '¿Está seguro de que quiere eliminar este rol?',

  //Permissions
  PleaseEnterADescription: 'Por favor ingrese una descripción',
  AddNewRolesToPermission: 'Agregar nuevos roles al permiso',
  DeleteRole: 'Eliminar rol',
  DeleteRoles: 'Eliminar roles',
  AddNewPermission: 'Agregar nuevo permiso',
  AddPermission: 'Agregar permiso',
  //Admin
  CreatePartnerOrganization: 'Crear organización asociada',
  DeletePartnerOrganization: 'Eliminar organización asociada',
  ManageDefaultRoles: 'Administrar roles predeterminados',
  ManagePermissions: 'Administrar permisos',
  //Partners
  BlockOrganization: 'Bloquear Organización',
  CreateOrganization: 'Crear Organización',
  DeleteOrganization: 'Eliminar Organización',
  ManageLicenses: 'Administrar licencias',
  ManageRoleAssignment: 'Administrar asignaciones de roles',
  //Organization
  CreateProject: 'Crear Proyecto',
  ManageGroups: 'Administrar grupos',
  ManageOrganizationInfo: 'Administrar información de la organización',
  ManageOrganizationRoleAssignments: 'Administrar asignaciones de funciones de la organización',
  ManageUsers: 'Administrar usuarios',
  AddOrganization: 'Agregar Organización',
  //Project
  CreateDrillhole: 'Crear Pozo',
  DeleteProject: 'Eliminar proyecto',
  ManageProjectInfo: 'Administrar información del proyecto',
  ManageProjectRoleAssignments: 'Administrar asignaciones de roles',
  ViewProjectData: 'Ver datos del proyecto',
  //Ring
  CreateRing: 'Crear banco',
  DeleteRing: 'Eliminar banco',
  ManageRingInfo: 'Administrar información de banco',
  ManageRingRoleAssignments: 'Administrar asignaciones de roles de banco',
  ShareRing: 'Compartir banco',
  ViewRingData: 'Ver datos de banco',
  CreateRingDrillhole: 'Crear pozos de banco',
  //Drillhole
  ManageQuarantine: 'Administrar cuarentena',
  ManageRecycleBin: 'Administrar papelera de reciclaje',
  ManageRoles: 'Administrar roles',
  ManageUnitSystem: 'Gestionar sistema de unidades',

  //GroupViews
  RowsSelected: 'fila(s) seleccionada(s)',
  AddToMembers: 'Agregar a miembros',
  AssignRolesToGroup: 'Asignar roles al grupo',
  Scope: 'Contexto',
  ScopeType: 'Tipo de contexto',
  SearchScope: 'Contexto de búsqueda',
  AddGroup: 'Agregar Grupo',
  AddNewGroup: 'Agregar nuevo grupo',
  DeleteGroup: 'Eliminar Grupo',
  DeleteGroups: 'Eliminar grupos',
  GroupLogs: 'Registros del grupo',
  GroupInfo: 'Información del grupo',
  GroupMembers: 'Miembros del grupo',
  CheckGroupInfoAndUsersTabs: 'Por favor revise la información del grupo y las pestañas de miembros. Algo está mal',

  //Organizations:
  PleaseCheckTheInfoProvided: 'Por favor, compruebe la información proporcionada. Algo está mal',
  PleaseSelectOrRemoveRow: 'Seleccione o elimine una fila',
  AreYouSureRemoveMemberFromOrg: '¿Está seguro de que desea eliminar a {0} miembro de la organización?',
  AreYouSureRemoveMembersFromOrg: '¿Está seguro de que desea eliminar a {0} miembros de la organización?',
  DeleteUsers: 'Eliminar Usuarios',
  InvitationSent: 'Invitación enviada',
  InvitationNotSent: 'Invitación no enviada',
  ResendInvitation: 'Reenviar invitación',
  SendResetPasswordEmail: 'Enviar correo electrónico de restablecimiento de contraseña',
  ResetPasswordEmailSent: 'Correo electrónico enviado',
  ResetPasswordEmailNotSent: 'Correo electrónico no enviado',
  TypeOrganizationNameToConfirm: 'Escriba el nombre de la organización para confirmar',
  CanNotDeletePartnerOrganizations: 'No se pueden eliminar las organizaciones asociadas',
  CanNotDeleteOrganizations: 'No se pueden eliminar organizaciones',
  CheckOrganizationInfoAndUsersTabs: 'Verifique la información de la organización y las pestañas de usuarios. Algo está mal',
  AddNewOrganization: 'Agregar nueva organización',
  SelectOrInviteOrganizationMaster: 'Seleccionar o invitar a la organización principal',
  PleaseSelectInviteOrRemoveRow: 'Seleccione, invite o elimine la fila',
  AddUser: 'Agregar Usuario',
  AddNewUser: 'Agregar nuevo usuario',

  //Users
  RemoveMembership: 'Eliminar Membresía',
  RemoveMemberships: 'Eliminar Membresías',
  UsersLogs: 'Registros del usuario',
  AssignRolesToUser: 'Asignar roles al usuario',
  RolesAssigned: 'Roles asignados',
  BalnkPasswordWarning:
    'Si deja el campo de contraseña en blanco, el sistema asumirá que este usuario utilizará un proveedor de autenticación externo para iniciar sesión.',
  DeleteUser: 'Eliminar usuario',
  ConfirmDeleteUser: '¿Está seguro de que desea eliminar el usuario "{0}" con la dirección de correo electrónico "{1}"?',
  UserDeleted: 'El usuario "{0}" con la dirección de correo electrónico "{1}" se eliminó con éxito.',
  //AuditLogs
  Timestamp: 'Marco de tiempo',
  NotificationTimestampMessageMinutes: 'hace {0} minutos',
  DisplayingFilteredItems: 'Mostrando elementos filtrados por una notificación.',
  ShowAllItems: 'Mostrar todos los elementos',
  NotificationTimestampMessageHours: 'hace {0} horas',
  Yesterday: 'Ayer',
  Read: 'Leído',
  Unread: 'No leído',
  Action: 'Acción',
  AffectedElement: 'Elemento afectado',
  LinkTo: 'Enlace a',
  State: 'Estado',
  Date: 'Fecha',
  Notifications: 'Notificaciones',
  NotificationStatus: 'Estado de la notificación',
  InApp: 'En la aplicación',
  NotificationsSettings: 'Configuración de notificaciones',
  DeleteAfter: 'Eliminar después de',
  OneWeek: 'Una semana',
  OneMonth: 'Un mes',
  OneYear: 'Un año',
  ThreeMonths: 'Tres meses',
  SixMonths: 'Seis meses',
  DeleteAllNotifications: 'Eliminar todas',
  SurveySynchedRingNotificationDescription: 'La medición "{A}" ha sido sincronizada en el pozo "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'La medición "{A}" ha sido sincronizada en el banco "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'La medición "{A}" ha sido sincronizada en la cuarentena.',
  OrganizationCreationFinishedNotificationTitle: 'Organización creada',
  OrganizationExpirationWarningNotificationTitle: 'La organización está por expirar',
  OrganizationCreationErrorNotificationTitle: 'Error al crear la organización',
  OrganizationIsAvailableNotificationTitle: 'Organización disponible',
  LicenseNeedsApprovalNotificationTitle: 'La licencia necesita aprobación',
  LicenseWasRenewedNotificationTitle: 'La licencia fue renovada',
  RingCreatedNotificationTitle: 'Banco creado',
  SurveySynchedNotificationTitle: 'Medición sincronizada',
  ProjectDeletedNotificationTitle: 'Proyecto eliminado',
  ProjectEditedNotificationTitle: 'Proyecto editado',
  DrillholeDeletedNotificationTitle: 'Pozo eliminado',
  RingDeletedNotificationTitle: 'Banco eliminado',
  DrillholeMovedNotificationTitle: 'Pozo movido',
  RingMovedNotificationTitle: 'Banco movido',
  DrillholeEditedNotificationTitle: 'Pozo actualizado',
  RingEditedNotificationTitle: 'Banco actualizado',
  SurveySignoffNotificationTitle: 'Solicitud de aprobación de medición',
  DrillholeCreatedNotificationTitle: 'Pozo creado',
  BulkDrillholesUpdateNotificationTitle: 'Pozos editados',
  BulkDrillholesMovedNotificationTitle: 'Pozos movidos',
  BulkRingsMovedNotificationTitle: 'Bancos movidos',
  BulkDrillholesDeletedNotificationTitle: 'Pozos eliminados',
  BulkRingsDeletedNotificationTitle: 'Bancos eliminados',
  BulkProjectsDeletedNotificationTitle: 'Proyectos eliminados',
  BulkRingsCreatedNotificationTitle: 'Bancos creados',
  BulkDrillholesCreatedNotificationTitle: 'Pozos creados',
  SurveyDeletedNotificationTitle: 'Medición eliminada',
  SurveyDeletedNotificationDescription: 'La medición "{A}" fue eliminada.',

  OrganizationCreationFinishedNotificationDescription: 'La organización {A} fue creada con {X} miembros.',
  OrganizationExpirationWarningNotificationDescription: 'La organización {A} está por expirar.',
  OrganizationCreationErrorNotificationDescription: 'Hubo un error al crear la organización {A}.',
  OrganizationIsAvailableNotificationDescription: 'La organización {A} ya está disponible.',
  LicenseNeedsApprovalNotificationDescription: 'Una licencia con el código de herramienta {A} necesita aprobación.',
  LicenseWasRenewedNotificationDescription: 'Una licencia con el código de herramienta {A} fue renovada.',
  SurveySynchedNotificationDescription: 'La medición "{A}" ha sido sincronizada en el pozo "{B}".',
  ProjectDeletedNotificationDescription: 'El proyecto "{A}" fue eliminado.',
  ProjectEditedNotificationDescription: 'El proyecto "{A}" fue editado.',
  DrillholeDeletedNotificationDescription: 'El pozo "{A}" fue eliminado.',
  RingDeletedNotificationDescription: 'El banco "{A}" fue eliminado.',
  DrillholeMovedNotificationDescription: 'El pozo "{B}" fue movido a "{A}".',
  RingMovedNotificationDescription: 'El banco "{B}" fue movido al proyecto "{A}".',
  DrillholeEditedNotificationDescription: 'El pozo "{A}" fue actualizado',
  RingEditedNotificationDescription: 'El banco "{A}" fue actualizado',
  SurveySignoffNotificationDescription: 'Se solicitó una aprobación para la medición "{A}".',
  DrillholeCreatedNotificationDescription: 'Un pozo de nombre "{B}" ha sido creado en "{A}".',
  RingCreatedNotificationDescription: 'Un banco de nombre "{B}" fue creado en el proyecto "{A}".',
  BulkDrillholesUpdateNotificationDescription: 'Se editaron {X} pozos en "{B}".',
  BulkDrillholesMovedNotificationDescription: 'Se movieron {X} pozos a "{B}".',
  BulkRingsMovedNotificationDescription: 'Se movieron {X} bancos al proyecto "{B}".',
  BulkDrillholesDeletedNotificationDescription: 'Se eliminaron {X} pozos',
  BulkRingsDeletedNotificationDescription: 'Se eliminaron {X} bancos',
  BulkProjectsDeletedNotificationDescription: 'Se eliminaron {X} proyectos.',
  BulkRingsCreatedNotificationDescription: 'Se crearon {X} bancos.',
  BulkDrillholesCreatedNotificationDescription: 'Se crearon {X} pozos en "{B}".',
  ForgotPasswordNotificationTitle: 'Correo de restablecimiento de contraseña enviado',
  OrganizationInvitationNotificationTitle: 'Invitación a organización recibida',
  LicenseQRSharedNotificationTitle: 'Licencia compartida contigo',
  ToolUsageReportNotificationTitle: 'Reporte de uso de herramientas listo',
  OrganizationCreationFinishedNotificationTitleError: 'Error al crear la organización',
  OrganizationIsAvailableNotificationTitleError: 'Error al habilitar la organización',
  LicenseWasRenewedNotificationTitleError: 'Error al renovar la licencia',
  RingCreatedNotificationTitleError: 'Error al crear el banco',
  SurveySynchedNotificationTitleError: 'Error al sincronizar la medición',
  ProjectDeletedNotificationTitleError: 'Error al eliminar el proyecto',
  ProjectEditedNotificationTitleError: 'Error al editar el proyecto',
  DrillholeDeletedNotificationTitleError: 'Error al eliminar el pozo',
  RingDeletedNotificationTitleError: 'Error al eliminar el banco',
  DrillholeMovedNotificationTitleError: 'Error al mover el pozo',
  RingMovedNotificationTitleError: 'Error al mover el banco',
  DrillholeEditedNotificationTitleError: 'Error al actualizar el pozo',
  RingEditedNotificationTitleError: 'Error al actualizar el banco',
  DrillholeCreatedNotificationTitleError: 'Error al crear el pozo',
  BulkDrillholesUpdateNotificationTitleError: 'Error al editar los pozos',
  BulkDrillholesMovedNotificationTitleError: 'Error al mover los pozos',
  BulkRingsMovedNotificationTitleError: 'Error al mover los bancos',
  BulkDrillholesDeletedNotificationTitleError: 'Error al eliminar los pozos',
  BulkRingsDeletedNotificationTitleError: 'Error al eliminar los bancos',
  BulkProjectsDeletedNotificationTitleError: 'Error al eliminar los proyectos',
  BulkRingsCreatedNotificationTitleError: 'Error al crear los bancos',
  BulkDrillholesCreatedNotificationTitleError: 'Error al crear los pozos',
  SurveyDeletedNotificationTitleError: 'Error al eliminar la medición',
  ForgotPasswordNotificationTitleError: 'Error al enviar el correo de restablecimiento de contraseña',
  OrganizationInvitationNotificationTitleError: 'Error al enviar la invitación a la organización',
  LicenseQRSharedNotificationTitleError: 'Error al compartir la licencia',
  ToolUsageReportNotificationTitleError: 'Error al generar el informe de uso de las herramientas',

  SurveyDeletedNotificationDescriptionError: 'Hubo un error al eliminar la medición "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Hubo un error al crear la organización {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Hubo un error al habilitar la organización {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Hubo un error al renovar la licencia con código de herramienta {A}.',
  SurveySynchedNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en el pozo "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Hubo un error al eliminar el proyecto "{A}".',
  ProjectEditedNotificationDescriptionError: 'Hubo un error al editar el proyecto "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Hubo un error al eliminar el pozo "{A}".',
  RingDeletedNotificationDescriptionError: 'Hubo un error al eliminar el banco "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Hubo un error al mover el pozo "{B}" a "{A}".',
  RingMovedNotificationDescriptionError: 'Hubo un error al mover el banco "{B}" al proyecto "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Hubo un error al actualizar el pozo "{A}".',
  RingEditedNotificationDescriptionError: 'Hubo un error al actualizar el banco "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Hubo un error al crear el pozo "{A}" en "{B}".',
  RingCreatedNotificationDescriptionError: 'Hubo un error al crear el banco "{A}" en el proyecto "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Hubo un error al editar {X} pozos en "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Hubo un error al mover {X} pozos a "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Hubo un error al mover {X} bancos al proyecto "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Hubo un error al eliminar {X} pozos.',
  BulkRingsDeletedNotificationDescriptionError: 'Hubo un error al eliminar {X} bancos.',
  BulkProjectsDeletedNotificationDescriptionError: 'Hubo un error al eliminar {X} proyectos.',
  BulkRingsCreatedNotificationDescriptionError: 'Hubo un error al crear {X} bancos.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Hubo un error al crear {X} pozos en "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Hubo un error al enviar el correo de restablecimiento de contraseña.',
  OrganizationInvitationNotificationDescriptionError: 'Hubo un error con una invitación a la organización. Por favor, verifique.',
  LicenseQRSharedNotificationDescriptionError: 'Hubo un error al compartir la licencia.',
  ToolUsageReportNotificationDescriptionError: 'Hubo un error al generar o enviar el informe de uso de las herramientas.',
  SurveySynchedRingNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en el pozo "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en el banco "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en la cuarentena.',
  IsRead: 'Leído',
  RelatedEntityName: 'Nombre de entidad relacionada',
  RelatedEntityType: 'Tipo de entidad relacionada',
  RedirectEntityName: 'Nombre de entidad de redirección',
  RedirectEntityType: 'Tipo de entidad de redirección',
  Count: 'Cantidad',
  Enable: 'Habilitar',
  SendNotificationsViaEmail: 'Enviar notificaciones por correo electrónico',
  TypeHeader: 'Tipo',

  ForgotPasswordNotificationDescription: 'Se ha enviado un correo electrónico con un enlace para restablecer tu contraseña.',
  OrganizationInvitationNotificationDescription:
    'Has sido invitado a unirte a una organización. Por favor revisa tu correo electrónico para más detalles.',
  LicenseQRSharedNotificationDescription: 'Se ha compartido una licencia contigo. Por favor revisa tu correo electrónico para más detalles.',
  ToolUsageReportNotificationDescription: 'El reporte de uso de herramientas fue generado exitosamente y enviado a tu correo electrónico.',

  Now: 'Ahora',
  EmptyNotificationsTextTitle: '¡Ya estás al día!',
  EmptyNotificationsTextSubtitle: 'No tiene nuevas notificaciones',
  LastWeek: 'La semana pasada',
  Today: 'Hoy',
  ThisWeek: 'Esta semana',
  ThisMonth: 'Este mes',
  MarkAsRead: 'Marcar como leída',
  MarkAsReadAll: 'Marcar como leídas',
  LogType: 'Tipo de registro',
  RelatedEntity: 'Entidad relacionada',
  // Error
  UnexpectedError: 'Error inesperado',
  Unauthorized: 'No autorizado',
  NoAccessToAdminSite: 'No tiene acceso al sitio de administración',
  LoginOutInSecs: 'Cerrar sesión en {0} segundos',
  CrashError: '¡Ups! Algo salió realmente mal',
  SeeAllLogs: 'Presione F12 y envíe todos los registros en la pestaña Consola cuando informe este incidente',
  ReturnHome: 'Regresar a Home',
  OrganizationUsers: 'Usuarios de la organización',
  IsPartnerQuestion: '¿Es socio?',

  FixResult: 'Resultado',
  NoInconsistenciesFound: 'No se encontraron inconsistencias',
  Type: 'Escriba',
  Parent: 'Padre',
  'Parent Type': 'Tipo de padre',
  Problem: 'Problema',
  Fixed: 'Arreglado',
  PleaseTryAgainLater: 'Por favor, inténtelo de nuevo más tarde',
  FixInconsistencies: 'Arreglar inconsistencias',
  AssignRoleWarning:
    'Está asignando los roles: {0} a {1} a nivel de organización. Los roles se aplicarán a todas las entidades seleccionadas y {1} tendrá permiso para toda la información contenida en {2}',
  UpdateExpiredRoleWarning:
    'Los roles: {0} fueron asignados previamente a {1}, pero han expirado. La fecha seleccionada reemplazará la fecha de expiración anterior y los roles volverán a estar activos.',
  DoYouWantToContinue: '¿Quiere continuar?',
  MemberAlreadyInOrganizarion: 'El usuario ya es un miembro de la organización {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'Este usuario ha sido seleccionado más de una vez',
  ElementsSussessfulyDeleted: 'Elementos eliminados con éxito',
  rowsSelected: 'fila(s) seleccionada(s)',
  ImportCSV: 'Importar CSV',
  Licenses: 'Licencias',
  ToolCode: 'Código de Herramienta',
  DeviceType: 'Tipo de Dispositivo',
  FromDate: 'Desde la Fecha',
  UntilDate: 'Hasta la Fecha',
  CreatedOn: 'Creado En',
  CreatedBy: 'Creado por',
  Unlimited: 'Ilimitado',
  Coefficients: 'Coeficientes',
  Continuous: 'Continuo',
  Multishot: 'Multidisparo',
  Zupt: 'Zupt',
  Offline: 'Desconectado',
  Flash: 'Flash',
  Notes: 'Notas',
  AddLicense: 'Crear Licencia',
  AddNewLicense: 'Crear Nueva Licencia',
  PleaseEnterToolCode: 'Entre el código de la herramienta',
  LicenseCopied: 'Licencia copiada al portapapeles',
  License: 'Licencia',
  Copy: 'Copiar',
  ErrorLoadingLicense: 'Error al cargar la licencia',
  ShowLicense: 'Mostrar Licencia',
  GoToLicense: 'Ir a la licencia',
  LicenseAlreadyExists: 'Ya existe una licencia con los mismos parámetros ingresados',
  PeriodOfValidity: 'Periodo de Validez',
  CopyLicense: 'Copiar Licencia',
  CopyAll: 'Copiar Todo',
  PleaseSelectDates: 'Por favor, seleccione el rango de fechas',
  Project: 'Proyecto',
  Customer: 'Cliente',
  ExportCSV: 'Exportar CSV',
  Reports: 'Reportes',
  Export: 'Exportar',
  Separator: 'Separador',
  Tab: 'Tab',
  Semicolon: 'Punto y coma',
  Comma: 'Coma',
  ThereWasAProblemCreatingLicense: 'Hubo un problema al crear la licencia. Por favor, comuníquese con un administrador.',
  ExpirationDate: 'Fecha de vencimiento',
  UpdateRoleAttributes: 'Actualizar atributos de rol',
  Update: 'Actualizar',
  AllowedDevices: 'Dispositivos Permitidos',
  RoleExpirationDate: 'Fecha de vencimiento del rol',
  PleaseEnterExpirationDate: 'Por favor, ingrese una fecha de vencimiento',
  MaximumLicenseDueDate: 'Fecha máxima de vencimiento de la licencia',
  PleaseEnterMaxDueDate: 'Por favor, ingrese la fecha máxima de vencimiento de la licencia',
  MaxLicensesPeriodInDays: 'Período máximo de licencia (días)',
  PleaseEnterMaxLicensesPeriodInDays: 'Por favor, ingrese el período máximo de licencia en días',
  MaxNumberOfLicensesPerMonth: 'Máximo # de licencias por mes',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Por favor, ingrese el número máximo de licencias por mes',
  SignOffPending: 'Aprobación Pendiente',
  SignedOffBy: 'Aprobado por',
  SignedOffOn: 'Aprobado en',
  SignOff: 'Aprobar',
  Refuse: 'Rechazar',
  NeedsSignOff: 'Se necesita aprobación',
  SelectedUserAlreadyHasTheSelectedRoles: 'El usuario seleccionado ya tiene los roles: {0}.',
  CanCreateUnlimitedLicense: 'Puede crear licencias que no caducan',
  CanCreateRecurrentLicenses: 'Puede crear licencias recurrentes',
  Recurrence: 'Recurrencia',
  Activated: 'Activado',
  Deactivated: 'Desactivado',

  Logs: 'Registros',
  LicenseLogs: 'Registros de licencias',
  ViewLogs: 'Ver Registros',
  UserName: 'Nombre de usuario',
  LicenseCreation: 'Creación de licencia',
  LicenseUpdate: 'Actualización de licencia',
  LicenseSignedOff: 'Licencia Firmada',
  LicenseRejected: 'Licencia Rechazada',
  ErrorCreatingLicenseMaximumLicenseDueDate: 'Error al crear licencia',
  ErrorCreatingLicenseMaxLicensesPeriodInDays: 'Error al crear licencia',
  ErrorCreatingLicenseMaxLicenseNumber: 'Error al crear licencia',
  ErrorCreatingLicenseAllowedDevices: 'Error al crear licencia',
  ErrorUpdatingLicenseMaximumLicenseDueDate: 'Error al actualizar la licencia',
  ErrorUpdatingLicenseMaxLicensesPeriodInDays: 'Error al actualizar la licencia',
  ErrorUpdatingLicenseAllowedDevices: 'Error al actualizar la licencia',
  LicenseCreationDescription: 'Una licencia fue creada por {0} para el dispositivo {1} con tipo de herramienta {2}.',
  LicenseUpdateDescription: 'Una licencia fue actualizada por {0}',
  LicenseCreationDescriptionExtraData:
    'Una licencia fue creada por {0} con los siguientes parámetros: Tipo de dispositivo: {1}, Número de herramienta: {2}, {3}, Proyecto: {4}, Cliente: {5}.',
  LicenseUpdateDescriptionExtraData:
    'Una licencia fue actualizada por {0}.<br> Parámetros anteriores: Tipo de dispositivo: {1}, Número de herramienta: {2}, {3}, Proyecto: {4}, Cliente: {5}.<br> Parámetros actuales: Tipo de dispositivo: {6}, Número de herramienta: {7}, {8}, Proyecto: {9}, Cliente: {10}.',
  LicenseDescriptionTimeData: 'desde {0} hasta {1}',
  LicenseSignedOffDescription: '{0} aprobó la licencia creada por {1} para el dispositivo {2} y el tipo de herramienta {3}',
  LicenseRejectedDescription: '{0} rechazó la licencia creada por {1} para el dispositivo {2} y el tipo de herramienta {3}.',
  ErrorCreatingLicenseMaximumLicenseDueDateDescription:
    'Se ha producido un error al crear la licencia. La licencia no puede tener una fecha de vencimiento posterior a la fecha de vencimiento máxima permitida',
  ErrorCreatingLicenseMaxLicensesPeriodInDaysDescription:
    'Se ha producido un error al crear la licencia. La licencia debe ser válida por un período inferior al período máximo de licencia permitido.',
  ErrorCreatingLicenseMaxLicenseNumberDescription:
    'Se ha producido un error al crear la licencia. El usuario superó el número máximo de licencias que se pueden crear en un mes',
  ErrorCreatingLicenseAllowedDevicesDescription:
    'Se ha producido un error al crear la licencia. El usuario no tiene permisos para crear licencias para el dispositivo especificado',
  ErrorUpdatingLicenseMaximumLicenseDueDateDescription:
    'Se ha producido un error al actualizar la licencia. La licencia no puede tener una fecha de vencimiento posterior a la fecha de vencimiento máxima permitida',
  ErrorUpdatingLicenseMaxLicensesPeriodInDaysDescription:
    'Se ha producido un error al actualizar la licencia. La licencia debe ser válida por un período inferior al período máximo de licencia permitido',
  ErrorUpdatingLicenseAllowedDevicesDescription:
    'Se ha producido un error al actualizar la licencia. El usuario no tiene permisos para definir licencias para el dispositivo especificado.',
  ExportingVeryLargeNumberOfItems:
    'Está intentando exportar una gran cantidad de elementos, esto podría llevar algún tiempo. ¿Está seguro de que desea continuar?',
  InitializingOrganization: 'Inicializando Organización. Los usuarios estarán disponibles pronto',
  InvalidToolCode: 'El código de la herramienta debe tener exactamente cuatro dígitos',
  EditRoles: 'Editar roles',
  EditRolesMessage: 'Editar roles de usuario',
  RolesWillBeRemoved: 'Se eliminarán los siguientes roles: {0}. ',
  RolesWillBeAssigned: 'Se asignarán los siguientes roles: {0}. ',
  LicenseAttributesWillBeUpdated: 'Se actualizarán los atributos del rol License Manager',
  CheckDatabases: 'Comprobar bases de datos',
  CheckDatabasesComplete: 'La operación de comprobación de bases de datos ha finalizado',
  DatabaseCheckResultsModalTitle: 'Resultados de la comprobación de bases de datos:',
  ViewResults: 'Ver resultados',
  CheckDatabaseResult: 'Resultado de comprobar la base de datos',
  OrganizationName: 'Nombre de la Organización',
  Status: 'Estado',
  Success: 'Éxito',
  Error: 'Error',
  AddAssignments: 'Añadir Asignaciones',
  GroupsLogs: 'Registros de los Grupos',
  RelatedUser: 'Usuario relacionado',
  OrganizationInfo: 'Información de la organización',
  LicenseDetails: 'Detalles de la licencia',
  DatabaseCheckLogs: 'Registros de comprobación de bases de datos',
  CheckingDatabases: 'Comprobando bases de datos...',
  DatabaseLogs: 'Registros de bases de datos',
  DatabaseCheckLogsResult: 'Resultados de la comprobación de la base de datos',
  DatabaseCheckResultOnDate: 'Resultado de la comprobación de la base de datos en {0}',
  ExportingProcessStarted: 'El proceso de exportación ha comenzado, la descarga comenzará en breve',
  ExportOrganization: 'Exportar Organización',
  ImportOrganization: 'Importar Organización',
  UploadOrganizationBackup: 'Subir copia de seguridad de la organización',
  AddOrganizationFile: 'Haga clic o arrastre el archivo de copia de seguridad de la organización a esta área para cargar',
  ThisUserIsOrganizationMaster: 'Este usuario ya ha sido seleccionado como maestro de la organización',
  RemainingLicensesMessage: 'Le quedan un total de {0} licencias para este mes',
  MaxLicenseNumberReached: 'Ha alcanzado el número máximo de licencias para este mes',
  EULATitle: 'Acuerdo de licencia de usuario final (EULA)',
  OrganizationIsExporting: 'La organización se está exportando, por favor espere...',
  ErrorExportingOrganization: 'Se ha producido un error al exportar la organización {0}. Por favor, inténtelo de nuevo',
  ExportingOrganizationSuccess: 'El proceso de exportación ha comenzado, cuando termine enviaremos el enlace de descarga a su correo electrónico.',
  ExportImportLogs: 'Registros de Exportación e Importación',
  CanNotDeleteOrganizationWhileExporting:
    'La organización {0} está siendo exportada y no puede ser eliminada en este momento. Por favor, espere y vuelva a intentarlo dentro de un rato.',
  CheckingIfOrganizationExists: 'Comprobando si la organización existe...',
  RestoreOrganizationConfirmDialog:
    'Esta organización ya existe, ¿desea continuar? Todos los datos de esta organización se sobrescribirán con los datos de la copia de seguridad.',
  StatusCode: 'Código de Estado',
  Message: 'Mensaje',
  Traces: 'Trazas',
  ViewTrace: 'Ver Traza',
  ImportExportDevLogs: 'Registros de desarrollo de importación y exportación.',
  DevLogs: 'Registros de desarrollo',
  DevLogsShort: 'Reg. Desarrollo',
  ImportExport: 'Importación/Exportación',
  ImportingOrganizationStarted: 'El proceso de importación ha comenzado',
  ImportingOrganizationSuccess: 'El proceso de importación ha comenzado, cuando termine enviaremos una notificación a su correo electrónico.',
  ErrorImportingOrganization: 'Se ha producido un error al importar la organización. Por favor, inténtelo de nuevo',
  Importing: 'Importando...',
  ResetLockout: 'Restablecer bloqueo',
  LockoutReset: 'Bloqueo Restablecido',
  LockoutNotReset: 'Bloqueo No Restablecido',
  HangfireDashboard: 'Panel de Hangfire',
  LastImportDate: 'Esta organización se restauró por última vez a partir de una copia de seguridad el ',
  EventDuration: 'Duración del evento (horas)',
  ScheduledEvents: 'Eventos programados',
  ScheduledEvent: 'Evento programado',
  VisibilityStartDate: 'Fecha de inicio de visibilidad',
  VisibilityEndDate: 'Fecha de fin de visibilidad',
  EventType: 'Tipo de evento',
  ScheduledUpdate: 'Actualización programada',
  Announcement: 'Anuncio',
  EventStart: 'Inicio del evento',
  ScheduledEventsTableError: 'Hubo un error al cargar la tabla de eventos.',
  EditScheduledEvent: 'Editar evento programado',
  NewScheduledEvent: 'Nuevo evento programado',
  UploadBanner: 'Subir banner',
  Banner: 'Banner',
  BannerSelectInfoMessage:
    'Las imágenes de banner deben utilizar una relación de aspecto de 8:1 (ancho a alto). Las resoluciones recomendadas incluyen 800×100 píxeles, 1600×200 píxeles o cualquier otro tamaño que mantenga esta proporción. Podrá recortar la imagen antes de guardarla.',
  LocalizedAnnouncementInformation: 'Información de anuncio localizada',
  LocalizedAnnouncementInformationDescription:
    'Para cada idioma seleccionado, se mostrará un banner o un mensaje con la descripción proporcionada a todos los usuarios que utilicen ese idioma. Si se proporcionan tanto un banner como una descripción, la descripción se utilizará como texto alternativo del banner. Si el usuario utiliza un idioma no agregado, se usará la información del anuncio en inglés si está disponible y, de lo contrario, se utilizará la información del primer idioma de la lista.',
  AddAtLeastOneLanguage: 'Por favor, seleccione al menos un idioma',
  PleaseEnterVisibilityRange: 'Por favor, introduzca un rango de visibilidad',
  PleaseLoadImageIfNoDescription: 'Si no se proporciona una descripción, se debe cargar una imagen de banner',
  PleaseEnterDescriptionIfNoImage: 'Si no se proporciona una imagen de banner, se debe agregar una descripción de texto',
  PleaseEnterScheduledUpdateStartMoment: 'Por favor, introduzca un momento de inicio para la actualización',
  PleaseEnterScheduledUpdateDuration: 'Por favor, introduzca una duración en horas para la actualización',
  Link: 'Enlace',
  SelectBannerArea: 'Seleccionar área del banner',
  ScheduledMaintenanceText:
    'Mantenimiento programado: La plataforma en la nube estará en mantenimiento programado el {0}. Los servicios pueden verse interrumpidos durante una duración estimada de {1} horas, comenzando a las {2}',

  AdminRolesTableError: 'Se ha producido un error al cargar los roles de administrador. Inténtelo de nuevo',
  AuditLogsTableError: 'Se ha producido un error al cargar los registros de auditoría. Por favor, inténtelo de nuevo',
  DefaultRolesTableError: 'Se ha producido un error al cargar los roles por defecto. Por favor, inténtelo de nuevo',
  GroupsTableError: 'Se ha producido un error al cargar los grupos. Por favor, inténtelo de nuevo',
  ErrorSavingGroupProperties: 'Se ha producido un error al guardar las propiedades del grupo. Please try again',
  ErrorAddingGroupMembers: 'Se ha producido un error al añadir los miembros al grupo. Por favor, inténtelo de nuevo',
  GroupRolesTableError: 'Se ha producido un error al cargar los roles del grupo. Inténtelo de nuevo',
  LicensesTableError: 'Se ha producido un error al cargar las licencias. Por favor, inténtelo de nuevo',
  LicenseLogsTableError: 'Se ha producido un error al cargar los registros de licencias. Por favor, inténtelo de nuevo',
  OrganizationsTableError: 'Se ha producido un error al cargar las organizaciones. Por favor, inténtelo de nuevo',
  ErrorAddingOrganizationMembers: 'Se ha producido un error al añadir los nuevos miembros a la organización. Por favor, inténtelo de nuevo',
  ErrorRemovingOrganizationMembers: 'Se ha producido un error al eliminar los nuevos miembros de la organización. Por favor, inténtelo de nuevo',
  DatabaseLogsTableError: 'Se ha producido un error al cargar los registros de la base de datos. Por favor, inténtelo de nuevo',
  PermissionsTableError: 'Se ha producido un error al cargar los permisos. Por favor, inténtelo de nuevo',
  ErrorSavingPermissions: 'Se ha producido un error al guardar las propiedades de los permisos. Inténtelo de nuevo',
  ErrorAddingPermissionRoles: 'Se ha producido un error al añadir permisos al rol. Inténtelo de nuevo',
  ErrorRemovingPermissionRoles: 'Se ha producido un error al eliminar el permiso del rol. Por favor, inténtelo de nuevo',
  RoleAssignmentsTableError: 'Se ha producido un error al cargar las asignaciones de roles. Por favor, inténtelo de nuevo',
  RoleListTableError: 'Se ha producido un error al cargar los roles. Por favor, inténtelo de nuevo',
  LockoutNotResetError: 'Se ha producido un error al restablecer el bloqueo. Por favor, inténtelo de nuevo',
  UsersTableError: 'Se ha producido un error al cargar la lista de usuarios. Inténtalo de nuevo',
  ErrorAddingGroup: 'Se ha producido un error al añadir el grupo. Por favor, inténtalo de nuevo',
  ErrorRemovingGroup: 'Se ha producido un error al eliminar el grupo. Inténtalo de nuevo',
  UserLogsTableError: 'Se ha producido un error al cargar los registros de usuario. Por favor, inténtalo de nuevo',
  UserRolesTableError: 'Se ha producido un error al cargar los roles de usuario. Inténtelo de nuevo',
  InvitationNotSentErrorMessage: 'Se ha producido un error al enviar la invitación. Please try again',
  ResetPasswordEmailNotSentMessage: 'Se ha producido un error al enviar el correo electrónico de restablecimiento de contraseña. Inténtalo de nuevo',
  ErrorEditingLicenseAttributes: 'Se ha producido un error al editar la licencia. Inténtelo de nuevo',
  ErrorDeletingUser: 'Se ha producido un error al eliminar el usuario. Por favor, inténtelo de nuevo.',
  PaginationTotal: 'Mostrando {0} elementos de {1}',
  PaginationTotalItemsText: 'Mostrando {0}-{1} de {2} elementos',
  MinutesAbbreviation: 'min',
  EditTutorialInformation: 'Editar información del tutorial',
  Order: 'Orden',
  VideoOrder: 'Orden del video',
  FuntionTitle: 'Función',
  VideoFunction: 'Función del video',
  PleaseEnterVideoOrder: 'Por favor ingrese el orden del video',
  AddFunction: 'Agregar función',
  FunctionAlreadyExistsWarning: 'Ya existe una función con ese nombre. Por favor verifique.',
  SearchTutorials: 'Buscar tutoriales',
  VideoTutorials: 'Tutoriales en video',
  ManageVideoTutorialData: 'Administrar datos de tutoriales en video',
  SynchronizeThisVideoAfterOperationFinishes: 'Sincronizar este video después de que finalice la operación',
  AddTutorialInformation: 'Agregar información del tutorial',
  VideoId: 'ID del video',
  TutorialEnabledLabel: 'Este video tutorial está listo para ser visualizado por el usuario.',
  Title: 'Título',
  FunctionTitle: 'Función',
  View: 'Ver',
  SynchronizeVideos: 'Sincronizar videos',
  Synchronize: 'Sincronizar',
  ErrorCreatingVideo: 'Se produjo un error al crear el video. Por favor, verifique la información ingresada e inténtelo de nuevo.',
  ErrorEditingVideo: 'Se produjo un error al editar el video. Por favor, verifique la información ingresada e inténtelo de nuevo.',
  Duration: 'Duración',
  CheckDB: 'Verificar base de datos',
  Drillhole: 'Pozo',
  DeleteDrillhole: 'Eliminar pozo',
  ManageDrillholeInfo: 'Administrar información del pozo',
  ManageDrillholeRoleAssignments: 'Administrar asignación de roles de los pozos',
  ManageSurveys: 'Administrar mediciones',
  ShareDrillhole: 'Compartir pozo',
  SignOffSurveys: 'Firmar mediciones',
  SelectOrInviteUser: 'Seleccionar o invitar usuario',
  SelectOrInviteUsers: 'Seleccionar o invitar usuarios',
  ManageGlobalLicenses: 'Administrar licencias globales',
  ManageRoleAssignments: 'Administrar asignación de roles globales',
  ManageUnitSystems: 'Administrar sistemas de unidades',
  SynchronizeSurveys: 'Sincronizar mediciones',
  ViewDrillholeData: 'Ver datos de pozo',
  ViewSurveyData: 'Ver datos de medición',
  OrganizationLogs: 'Registros de las organizaciones',
  ExportOrganizationDBLogsModalTitle: 'Exportar registro de comprobación de las bases de datos de las organizaciones',
  Format: 'Formato',
  Restore: 'Restore',
  RestoreBackupConfirmMessage:
    '¿Desea restaurar esta copia de seguridad? Se perderá cualquier cambio realizado en la organización después de crear la copia de seguridad',
  RestoreBackupSuccessMessage:
    'El proceso de restauración de la copia de seguridad ha comenzado. Cuando termine le enviaremos un correo electrónico.',
  Backups: 'Copias de seguridad',
  OrganizationBackups: 'Copias de seguridad de las organizaciones',
  PreviousValue: 'Valor anterior',
  PreviousHierarchy: 'Jerarquía anterior',
  Source: 'Fuente',
  SourceTitle: 'Fuente para el registro con fecha {0}, valor anterior "{1}" y jerarquía anterior "{2}"',
  ViewSource: 'Ver Fuente',
  ScopeId: 'Id de contexto',
  CurrentParentId: 'Id de padre actual',
  PreviousParentId: 'Id de padre anterior',
  CurrentHierarchy: 'Jerarquía actual',
  ScopeLogType: 'Tipo de registro de contexto',
  Descendants: 'Descendientes',
  ViewDescendants: 'Ver descendientes',
  DatabaseInconsistencyLogs: 'Registros de inconsistencias de las bases de datos',
  InconsistencyFixStartedMessage:
    'El proceso de corrección de inconsistencias ha comenzado, una vez terminado el resultado será visible en la página de Registros de Organizaciones.',
  OrganizationIsLocked:
    'Esta organización está actualmente bloqueada porque está siendo utilizada en otro proceso. Por favor, espere y vuelva a intentarlo dentro de un rato.',
  Statistics: 'Estadísticas',
  Last24Hours: 'Últimas 24 horas',
  Last3Days: 'Últimos 3 días',
  Last7Days: 'Últimos 7 días',
  Last28Days: 'Últimos 28 días',
  FilterByDate: 'Filtrar por fecha',
  Projects: 'Proyectos',
  Surveys: 'Mediciones',
  ProjectsNumber: 'Número de proyectos',
  UsersNumber: 'Número de usuarios',
  SurveysNumber: 'Número de mediciones',
  CreationDate: 'Fecha de creación',
  LastUpdate: 'Última actualización',
  CustomDateRange: 'Rango de fechas personalizado',
  ErrorUpdatingRole: 'Hubo un error al actualizar los permisos del rol. Por favor, inténtelo de nuevo.',

  WorkingHours: 'Horas de trabajo',
  PleaseEnterWorkingHours: 'Por favor, ingrese las horas de trabajo',

  Weekly: 'Semanal',
  Monthly: 'Mensual',
  Quarterly: 'Trimestral',
  SharingDataSettings: 'Configuración de cesión de datos',
  EmailAddresses: 'Direcciones de correo electrónico',
  EmailFrequency: 'Frecuencia de correos electrónicos',

  Country: 'País',
  PleaseSelectCountry: 'Por favor, seleccione un país',

  // Country names
  Afghanistan: 'Afganistán',
  Albania: 'Albania',
  Algeria: 'Argelia',
  Andorra: 'Andorra',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antigua y Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Armenia',
  Australia: 'Australia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaiyán',
  Bahamas: 'Bahamas',
  Bahrain: 'Baréin',
  Bangladesh: 'Bangladés',
  Barbados: 'Barbados',
  Belarus: 'Bielorrusia',
  Belgium: 'Bélgica',
  Belize: 'Belice',
  Benin: 'Benín',
  Bhutan: 'Bután',
  Bolivia: 'Bolivia',
  'Bosnia and Herzegovina': 'Bosnia-Herzegovina',
  Botswana: 'Botsuana',
  Brazil: 'Brasil',
  Brunei: 'Brunéi',
  Bulgaria: 'Bulgaria',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Camboya',
  Cameroon: 'Camerún',
  Canada: 'Canadá',
  'Cape Verde': 'Cabo Verde',
  'Central African Republic': 'República Centroafricana',
  Chad: 'Chad',
  Chile: 'Chile',
  China: 'China',
  Colombia: 'Colombia',
  Comoros: 'Comoras',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Costa de Marfil',
  Croatia: 'Croacia',
  Cuba: 'Cuba',
  Cyprus: 'Chipre',
  'Czech Republic': 'República Checa',
  'Democratic Republic of the Congo': 'República Democrática del Congo',
  Denmark: 'Dinamarca',
  Djibouti: 'Yibuti',
  Dominica: 'Dominica',
  'Dominican Republic': 'República Dominicana',
  'East Timor': 'Timor Oriental',
  Ecuador: 'Ecuador',
  Egypt: 'Egipto',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Guinea Ecuatorial',
  Eritrea: 'Eritrea',
  Estonia: 'Estonia',
  Ethiopia: 'Etiopía',
  Fiji: 'Fiyi',
  Finland: 'Finlandia',
  France: 'Francia',
  Gabon: 'Gabón',
  Gambia: 'Gambia',
  Georgia: 'Georgia',
  Germany: 'Alemania',
  Ghana: 'Ghana',
  Greece: 'Grecia',
  Grenada: 'Granada',
  Guatemala: 'Guatemala',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bisáu',
  Guyana: 'Guyana',
  Haiti: 'Haití',
  Honduras: 'Honduras',
  Hungary: 'Hungría',
  Iceland: 'Islandia',
  India: 'India',
  Indonesia: 'Indonesia',
  Iran: 'Irán',
  Iraq: 'Irak',
  Ireland: 'Irlanda',
  Israel: 'Israel',
  Italy: 'Italia',
  Jamaica: 'Jamaica',
  Japan: 'Japón',
  Jordan: 'Jordania',
  Kazakhstan: 'Kazajistán',
  Kenya: 'Kenia',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kirguistán',
  Laos: 'Laos',
  Latvia: 'Letonia',
  Lebanon: 'Líbano',
  Lesotho: 'Lesoto',
  Liberia: 'Liberia',
  Libya: 'Libia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituania',
  Luxembourg: 'Luxemburgo',
  Madagascar: 'Madagascar',
  Malawi: 'Malaui',
  Malaysia: 'Malasia',
  Maldives: 'Maldivas',
  Mali: 'Malí',
  Malta: 'Malta',
  'Marshall Islands': 'Islas Marshall',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauricio',
  Mexico: 'México',
  Micronesia: 'Micronesia',
  Moldova: 'Moldavia',
  Monaco: 'Mónaco',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Morocco: 'Marruecos',
  Mozambique: 'Mozambique',
  Myanmar: 'Birmania',
  Namibia: 'Namibia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Países Bajos',
  'New Zealand': 'Nueva Zelanda',
  Nicaragua: 'Nicaragua',
  Niger: 'Níger',
  Nigeria: 'Nigeria',
  'North Korea': 'Corea del Norte',
  Norway: 'Noruega',
  Oman: 'Omán',
  Pakistan: 'Pakistán',
  Palau: 'Palaos',
  Panama: 'Panamá',
  'Papua New Guinea': 'Papúa Nueva Guinea',
  Paraguay: 'Paraguay',
  Peru: 'Perú',
  Philippines: 'Filipinas',
  Poland: 'Polonia',
  Portugal: 'Portugal',
  Qatar: 'Catar',
  'Republic of the Congo': 'República del Congo',
  'Republic of Macedonia': 'República de Macedonia',
  Romania: 'Rumania',
  Russia: 'Rusia',
  Rwanda: 'Ruanda',
  'Saint Kitts and Nevis': 'San Cristóbal y Nieves',
  'Saint Lucia': 'Santa Lucía',
  'Saint Vincent and the Grenadines': 'San Vicente y las Granadinas',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'Sao Tomé y Príncipe',
  'Saudi Arabia': 'Arabia Saudita',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Sierra Leona',
  Singapore: 'Singapur',
  Slovakia: 'Eslovaquia',
  Slovenia: 'Eslovenia',
  'Solomon Islands': 'Islas Salomón',
  Somalia: 'Somalia',
  'South Africa': 'Sudáfrica',
  'South Korea': 'Corea del Sur',
  'South Sudan': 'Sudán del Sur',
  Spain: 'España',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudán',
  Suriname: 'Surinam',
  Swaziland: 'Suazilandia',
  Sweden: 'Suecia',
  Switzerland: 'Suiza',
  Syria: 'Siria',
  Tajikistan: 'Tayikistán',
  Tanzania: 'Tanzania',
  Thailand: 'Tailandia',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad y Tobago',
  Tunisia: 'Túnez',
  Turkey: 'Turquía',
  Turkmenistan: 'Turkmenistán',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ucrania',
  'United Arab Emirates': 'Emiratos Árabes Unidos',
  'United Kingdom': 'Reino Unido',
  'United States of America': 'Estados Unidos',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Uzbekistán',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietnam',
  Yemen: 'Yemen',
  Zambia: 'Zambia',
  Zimbabwe: 'Zimbabue',

  TestOrganization: 'Organización de prueba',
  RemovalDate: 'Fecha de eliminación',
  IsTestOrganization: 'Es una organización de prueba',
  TestingEndDate: 'Fecha de fin de la prueba:',
  TestOrgConfirmationMessage:
    'La entidad ha sido establecida como una organización de prueba y se eliminará automáticamente en la fecha seleccionada. ¿Está seguro de que desea continuar?',

  Show: 'Mostrar',
  Changed: 'Cambiado',
  Unchanged: 'Sin cambios',

  Charts: 'Gráficos',

  CreationChartLegend: 'Creación',
  UpdateChartLegend: 'Actualización',

  Confirm: 'Confirmar',

  SelectOrInviteWarning: 'Por favor selecciona o invita',
  InvalidEmailWarning: 'Por favor selecciona o ingresa un correo electrónico válido',

  UserHasNoOrganizationsWarning:
    'Este usuario no forma parte de ninguna organización. Por favor, agréguelo a una organización antes de asignar roles.',
  UserHasNoOrganizationsGroupWarning:
    'Este usuario no forma parte de ninguna organización. Por favor, agréguelo a una organización antes de añadirlo a grupos.',

  'Customer Geologist': 'Geólogo cliente',
  'Drillhole Manager': 'Administrador de pozos',
  'Field Operator': 'Operador de campo',
  Geologist: 'Geólogo',
  'Global License Manager': 'Administrador de licencias globales',
  'License Manager': 'Administrador de licencias',
  'Organization Coordinator': 'Coordinador de la organización',
  'Organization Master': 'Maestro de la organización',
  'Partner Administrator': 'Administrador de socios',
  'Project Manager': 'Administrador de proyectos',
  'Project Viewer': 'Visualizador de proyectos',
  'Ring Manager': 'Administrador de bancos',
  ViewAllOrganizations: 'Ver todas las organizaciones',
  'Organizations Viewer': 'Visualizador de organizaciones',

  GlobalLicenseAlreadyExists:
    'Está intentando crear una nueva licencia global para {0} #{1} desde {6} hasta {7}, pero ya existe una licencia global creada para {0} #{1} desde {2} hasta {3} por {4} el {5}. ¿Desea continuar y crear una nueva licencia de todos modos?',
  UnlimitedGlobalLicenseAlreadyExists:
    'Ya existe una licencia global ilimitada creada para {0} #{1} por {2} el {3}. ¿Desea continuar y crear una nueva licencia de todos modos?',
  Continue: 'Continuar',

  EditWarningGlobalLicenseAlreadyExists: 'Ya existe una licencia global creada para {0} #{1} desde {2} hasta {3} por {4} el {5}. ¿Desea continuar?',
  EditWarningUnlimitedGlobalLicenseAlreadyExists: 'Ya existe una licencia global ilimitada creada para {0} #{1} por {2} el {3}. ¿Desea continuar?',
  EditWarningLicenseAlreadyExists:
    'Ya existe una licencia creada para {0} #{1} desde {2} hasta {3} por {4} el {5} en la organización {6}. ¿Desea continuar?',
  EditWarningUnlimitedLicenseAlreadyExists:
    'Ya existe una licencia ilimitada creada para {0} #{1} por {2} el {3} en la organización {4}. ¿Desea continuar?',

  UserLogin: 'Inicio de sesión de usuario',
  UserAccessOrganization: 'Acceso del usuario a la organización',
  UserLogout: 'Cierre de sesión de usuario',
  UserAddedToGroup: 'Usuario añadido al grupo',
  UserRemovedFromGroup: 'Usuario eliminado del grupo',
  RoleAssignedToUser: 'Rol asignado al usuario',
  RoleUnassignedToUser: 'Rol desasignado del usuario',
  RoleAssignedToGroup: 'Rol asignado al grupo',
  RoleUnassignedToGroup: 'Rol desasignado del grupo',
  InvitationAccepted: 'Invitación aceptada',
  BackupSuccess: 'Copia de seguridad exitosa',
  BackupError: 'Error en la copia de seguridad',
  RestoreBackupSuccess: 'Restauración de copia de seguridad exitosa',
  RestoreBackupError: 'Error al restaurar la copia de seguridad',
  PleaseEnterStartAndEndDate: 'Por favor, introduzca la fecha de inicio y fin',

  ActiveHours: 'Horas activa',
  Active: 'Activo',
  NotActive: 'No activo',
  FilterByActiveDates: 'Filtrar por fechas activa',
  ActiveDays: 'Días activa',
  SelectedGroupAlreadyHasTheSelectedRoles: 'El grupo seleccionado ya tiene los roles: {0}.',

  Apply: 'Aplicar',

  FilterMode: 'Modo de filtrado',
  AllSelected: 'Todos los seleccionados',
  AnyOfTheSelected: 'Cualquiera de los seleccionados',
  Download: 'Descargar',

  ErrorCreatingLicense: 'Error al crear la licencia',
  DeviceTypeNotAllowed: 'Tipo de dispositivo no permitido',

  RoleAssignmentAttributes: 'Atributos de asignación de roles',
  LicenseManagerRoleAttributes: 'Atributos del rol de administrador de licencias',

  'StructMaster User': 'Usuario de StructMaster',
  UseStructMaster: 'Usar StructMaster',

  StructmasterLicenses: 'Licencias de StructMaster',
  NewStructmasterLicenseAssignment: 'Nueva asignación de licencia de StructMaster',
  EditStructmasterLicenseAssignment: 'Editar asignación de licencia de StructMaster',
  UserAlreadyHasStructMasterRole: 'Error: Este usuario ya tiene el rol de StructMaster en esta organización',
  AddAnotherAssignment: 'Agregar otra asignación',
  AddRole: 'Agregar rol',
  SelectRole: 'Seleccionar rol',
  PleaseSelectRole: 'Por favor, seleccione un rol',
  DuplicatedRolesWarning: 'Hay roles duplicados en su selección. Asegúrese de que no haya roles repetidos.',
  RolesWillBeUpdated: 'Se actualizarán los siguientes roles: {0}.',

  UserHasNoRoleWarning: 'El usuario debe tener al menos un rol en la organización',

  UserWillBeAddedToOrganizationBeforeAssign:
    'Advertencia: El usuario "{0}" no pertenece a la organización "{1}", por lo tanto, el usuario "{0}" será añadido a la organización antes de realizar la asignación.',

  ManageCategories: 'Gestionar categorías',
  ManageGeographicInformationSystems: 'Gestionar sistemas de información geográfica',
  RoleExpirationDateChanged: 'Fecha de vencimiento del rol cambiada',

  Appearance: 'Apariencia',
  DarkTheme: 'Tema oscuro',
  LightTheme: 'Tema claro',
  UseSystemTheme: 'Usar tema del sistema',
  MFAStatus: 'Estado de autenticación multifactor',
  Enabled: 'Habilitado',
  Disabled: 'Deshabilitado',
  EnableMFA: 'Habilitar autenticación multifactor',
  DisableMFA: 'Deshabilitar autenticación multifactor',

  UserLimit: 'Límite de usuarios',
  PleaseEnterUserLimit: 'Por favor, ingrese el límite de usuarios',
  CheckLicenseInfoAndUsersTabs: 'Por favor, revise la información de la licencia y las pestañas de usuarios. Algo está mal',
  LicenseInfo: 'Información de licencia',
  AddNewStructmasterLicense: 'Agregar nueva licencia StructMaster',
  StructmasterLicense: 'Licencia StructMaster',
  PleaseAddAtLeastOneUser: 'Por favor, agregue al menos un usuario',
  DuplicatedUserWarning: 'Este usuario ya ha sido seleccionado, por favor verifique',
  LicenseName: 'Nombre de la licencia',
  UserAmountExceedLimit: 'La cantidad de usuarios ingresada excede el límite seleccionado, por favor verifique que los datos sean correctos.',

  UserAlreadyIsLicenseManagerError: 'Este usuario ya pertenece a un grupo de administradores de licencias. Por favor, seleccione otro usuario',
  UserAlreadyIsStructmasterUserError: 'Este usuario ya tiene el rol de StructMaster. Por favor, seleccione otro usuario',
  DefaultGroups: 'Grupos predeterminados',
  LicenseManagerGroups: 'Grupos de administradores de licencias',
  UpdateAttributes: 'Actualizar atributos',
  ResetLicenseAccess: 'Restablecer acceso a la licencia',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Este usuario ya pertenece a un grupo de administradores de licencias, y hay al menos un grupo de administradores de licencias en su selección. Por favor, revíselo',
  MoreThanOneLicenseManagerGroupSelectedError:
    'Hay más de un grupo de administradores de licencias en su selección, y un usuario solo puede pertenecer a un único grupo de administradores de licencias. Por favor, revise su selección.',
  Default: 'Predeterminado',

  UnblockStructmasterLicense: 'Desbloquear licencia de StructMaster',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Ya existe una licencia de StructMaster con este nombre, por favor seleccione un nombre diferente.',
  ThereIsAlreadyAGroupWithThisName: 'Ya existe un grupo con este nombre, por favor seleccione un nombre diferente',

  GroupLogsTableError: 'Se produjo un error al cargar los registros de auditoría del grupo. Por favor, inténtelo de nuevo.',
  DownloadQR: 'Descargar QR',

  SelectUsersToShare: 'Seleccionar usuarios para compartir',
  SelectOrEnterEmailAddress: 'Seleccionar usuario o ingresar dirección de correo',
  Share: 'Compartir',
  NoUsersSelectedError: 'Por favor, seleccione al menos un usuario o ingrese una dirección de correo electrónico',
  AddEmail: 'Agregar correo electrónico',
  FilterByUser: 'Filtrar por usuario',
  ApprovalPending: 'Aprobación Pendiente',

  ActiveUser: 'Usuario activo',

  AllowAllPermissionsForThisLevel: 'Permitir todos los permisos para este nivel',
  AllowAllAvailablePermissions: 'Permitir todos los permisos disponibles',
  AllowAllAvaliablePermissionsForThisSelector: 'Permitir todos los permisos disponibles para este selector',

  StructmasterLicensesOnlyOneActiveUserWarning: 'Advertencia: Solo puede haber un usuario activo a la vez por cada licencia de StructMaster.',

  OrganizationUserLimitWarningCreation: 'Advertencia: Solo puede agregar un máximo de {0} usuarios a una organización',
  OrganizationUserLimitWarningParam:
    'Advertencia: Solo puede agregar un máximo de {0} usuarios a esta organización y ya tiene un total de {1}, por lo que solo podrá agregar un total de {2}.',
  OrganizationReachedUserLimit: 'Error: Esta organización ya tiene el número máximo de usuarios permitidos. Por favor seleccione otra organización.',
  NewGroupUserCountErrorParam:
    'Error: Esta organización permite un máximo de {0} usuarios, actualmente tiene {1} usuarios, y está intentando agregar {2} nuevos. Verifique que la información sea correcta.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Los siguientes usuarios serán añadidos a la organización:',

  UnsignedStructmasterLicenses: 'Licencias StructMaster sin aprobar',
  SaveAndSignOff: 'Guardar y aprobar',
  SignOffStructmasterLicenseWarningTitle: 'Aprobar licencia StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Está a punto de aprobar la creación de una nueva licencia StructMaster. Los usuarios se agregarán a la organización seleccionada si aún no están en ella y se les asignará el rol. ¿Desea continuar?',

  ShowOnlyUnsignedLicenses: 'Mostrar solo licencias pendientes de aprobación',
  ClearFilters: 'Limpiar filtros',
  ApproveLicenses: 'Aprobar licencias',

  SoftwareVersion: 'Versión del software',
  DeleteUnsignedLicense: 'Eliminar licencia sin aprobar',
  DeleteUnsignedLicenseWarning: '¿Está seguro de que desea eliminar la licencia sin aprobar "{0}"?',
  ErrorUpdatingLicense: 'Error al actualizar la licencia',
  DuplicatedRoleNameErrorCreate:
    'Error al crear el rol: Ya existe un rol con el nombre "{0}" en la organización "{1}". Por favor, ingrese un nombre diferente.',
  DuplicatedRoleNameErrorUpdate:
    'Error al actualizar el rol: Ya existe un rol con el nombre "{0}" en la organización "{1}". Por favor, ingrese un nombre diferente.',
  DuplicatedDefaultRoleNameErrorUpdate:
    'Error al actualizar el rol: Ya existe un rol predeterminado con el nombre "{0}". Por favor, ingrese un nombre diferente.',
  PleaseEnterAValidSearchTerm: 'Por favor, introduzca un término de búsqueda válido',
  TextFieldLimitError: 'El campo "{0}" no debe exceder de {1} caracteres',
  InvalidToolcode: 'Por favor, ingresa un código de herramienta válido',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Los grupos de administradores de licencias deben tener al menos un rol',
  PleaseSelectAtLeastOneDeviceType: 'Por favor seleccione al menos un tipo de dispositivo',
  Language: 'Lenguaje',

  UnsignedLicenseCreation: 'Creación de licencia sin firmar',
  SignedLicenseCreation: 'Creación de licencia firmada',
  UnsignedLicenseUpdate: 'Actualización de licencia sin firmar',
  SignedLicenseUpdate: 'Actualización de licencia firmada',
  ErrorCreatingUnsignedLicense: 'Error al crear la licencia sin firmar',
  ErrorCreatingSignedLicense: 'Error al crear la licencia firmada',
  ErrorUpdatingUnsignedLicense: 'Error al actualizar la licencia sin firmar',
  ErrorUpdatingSignedLicense: 'Error al actualizar la licencia firmada',
  DeleteSignedLicense: 'Eliminar licencia firmada',
  StructmasterLicenseLogs: 'Registros de licencias de StructMaster',
  PleaseEnterCoreDiameter: 'Por favor, introduzca el diámetro del núcleo',
  CoreDiameter: 'Diámetro del núcleo',

  AllowedGrantTypes: 'Tipos de concesión permitidos',
  Clients: 'Clientes',
  ClientsTableError: 'Hubo un error cargando los clientes. Por favor, inténtelo de nuevo.',
  AllowedScopes: 'Ámbitos permitidos',
  Implicit: 'Implícito',
  Hybrid: 'Híbrido',
  AuthorizationCode: 'Código de autorización',
  ClientCredentials: 'Credenciales de cliente',
  ResourceOwnerPassword: 'Contraseña del propietario del recurso',
  DeviceFlow: 'Flujo de dispositivo',
  Profile: 'Perfil',
  Phone: 'Teléfono',
  OfflineAccess: 'Acceso sin conexión',
  RedirectUris: 'URIs de redirección',
  PostLogoutRedirectUris: 'URIs de redirección tras cierre de sesión',
  AccessTokenType: 'Tipo de token de acceso',
  RefreshTokenUsage: 'Uso del token de actualización',
  AccessTokenLifetime: 'Tiempo de vida del token de acceso',
  AbsoluteRefreshTokenLifetime: 'Duración absoluta del token de actualización',
  AllowAccessTokensViaBrowser: 'Permitir tokens de acceso a través del navegador',
  AllowOfflineAccess: 'Permitir acceso sin conexión',
  AlwaysIncludeUserClaimsInIdToken: 'Incluir siempre las reclamaciones del usuario en el Id Token',
  RequirePkce: 'Requerir PKCE',
  RequireConsent: 'Requerir consentimiento',
  RequireClientSecret: 'Requerir secreto de cliente',
  ClientID: 'ID de cliente',
  ClientName: 'Nombre del cliente',
  ProtocolType: 'Tipo de protocolo',
  NewClient: 'Nuevo cliente',
  EditClient: 'Editar cliente',
  General: 'General',
  ClientSecrets: 'Secretos del cliente',
  PleaseEnterAClientId: 'Por favor, introduzca un ID de cliente',
  PleaseEnterAClientName: 'Por favor, introduzca un nombre de cliente',
  ReUse: 'Reutilizar',
  OneTimeOnly: 'Solo una vez',
  PleaseSelectTheAllowedScopes: 'Por favor, seleccione los ámbitos permitidos',
  AddRedirectUri: 'Agregar URI de redirección',
  AddPostLogoutRedirectUri: 'Agregar URI de redirección tras cierre de sesión',
  PleaseEnterRedirectURI: 'Por favor, introduzca un URI de redirección',
  PleaseEnterPostLogoutRedirectURI: 'Por favor, introduzca un URI de redirección tras cierre de sesión',
  Value: 'Valor',
  PleaseEnterSecretValue: 'Por favor, introduzca el valor secreto',
  PleaseEnterSecretDescription: 'Por favor, introduzca la descripción del secreto',
  AddClientSecret: 'Agregar secreto de cliente',
  NoRedirectUriWarning: 'Por favor, agregue al menos un URI de redirección en la pestaña "URIs de redirección"',
  NoPostLogoutRedirectUriWarning: 'Por favor, agregue al menos un URI de redirección tras cierre de sesión en la pestaña "URIs de redirección"',
  NoSecretsWarning: 'Si "Requerir secreto de cliente" está marcado, debe agregar al menos un secreto en la pestaña "Secretos del cliente"',
  PleaseSelectTheAllowedGrantTypes: 'Por favor, seleccione los tipos de concesión permitidos',
  RedirectURIMustNotBeEmpty: 'El valor del URI de redirección no debe estar vacío',
  PostLogoutRedirectURIMustNotBeEmpty: 'El valor del URI de redirección tras cierre de sesión no debe estar vacío',
  SecretValueMustNotBeEmpty: 'El valor del secreto no debe estar vacío',
  SecretDescriptionMustNotBeEmpty: 'La descripción del secreto no debe estar vacía',
  AllDataEnterdIsCorrect: 'Todos los datos introducidos son correctos',
  NoChangesMadeWarning: 'No hay cambios para guardar. Actualice cualquier campo para continuar.',
  ConfirmEditSecretValueTitle: 'Confirmar edición del valor secreto',
  ConfirmEditSecretValueMessage:
    '¿Está seguro de que desea editar el valor del secreto con la descripción "{0}"? Si continúa, el valor secreto anterior se perderá.',
  ManageClients: 'Gestionar clientes',
  Usage: 'Uso',

  GlobalSmartCoreLicenseAlreadyExists:
    'Estás intentando crear una nueva licencia global para {0} #{1} desde {6} hasta {7} con un diámetro de herramienta "{8}", pero ya existe una licencia global creada para {0} #{1} con diámetro de herramienta "{8}" desde {2} hasta {3} por {4} el {5}. ¿Quieres continuar y crear una nueva licencia de todos modos?',
  UnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Ya existe una licencia global ilimitada creada para {0} #{1} con un diámetro de herramienta "{4}" por {2} el {3}. ¿Quieres continuar y crear una nueva licencia de todos modos?',
  EditWarningGlobalSmartCoreLicenseAlreadyExists:
    'Ya existe una licencia global creada para {0} #{1} con diámetro de herramienta "{7}" desde {2} hasta {3} por {4} el {5}. ¿Quieres continuar?',
  EditWarningUnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Ya existe una licencia global ilimitada creada para {0} #{1} con diámetro de herramienta "{5}" por {2} el {3}. ¿Quieres continuar?',
  ToolDiameter: 'Diámetro de la herramienta',
  ToolcodeTooLarge: 'El código de la herramienta es demasiado grande. El código debe ser un número entre 1 y 65535',
  NotAllChildrenAreTestOrganizations:
    'Esta organización no puede configurarse como una organización de prueba porque al menos una de sus organizaciones hijas no es de prueba',
  'License Reviewer': 'Revisor de licencias',
  'Client Manager': 'Administrador de clientes',
  MeasurementCount: 'Mediciones',
  ToolSerialNumber: 'Número de serie de la herramienta',
  ExportCsvReport: 'Exportar informe CSV',
  ToolType: 'Tipo de herramienta',
  FirstUsedOn: 'Fecha de primer uso',
  LastUsedOn: 'Fecha de último uso',
  ErrorGeneratingReport: 'Hubo un error al generar el informe. Por favor, inténtelo de nuevo.',
  ToolUsageReport: 'Informe de uso de herramientas',
  ExportToolUsageReport: 'Exportar informe de uso de herramientas',
  ToolUsageReportInProcess:
    'El informe de uso de la herramienta está siendo generado. Se enviará a tu dirección de correo electrónico cuando esté listo.',
  ProjectName: 'Nombre del proyecto',
  ManagePartnerOrganization: 'Administrar organización de socios',
  ManageAdminOrganization: 'Administrar organización administradora',
};
